<template>
    <div class="card">
        <header class="card-header">
            <router-link to="/cars/" class="card-header-title">
                Cars sold
            </router-link>
            <router-link to="/cars/" class="card-header-icon" aria-label="more options">
                  <span class="icon has-text-danger">
                      <i class="fas fa-chart-line"></i>
                  </span>
            </router-link>
        </header>
        <div class="card-content">
            <router-link to="/cars/" class="total has-text-primary">{{ totalCarsSold }}</router-link>
        </div>
    </div>
</template>

<script>
    import apiCars from '../../../api/apiCars'
    export default {
        data() {
            return {
                totalCarsSold: 0
            }
        },
        mounted() {
            apiCars
                .carsListRequest({ order_column: 'lot_date', order_type: 'DESC',})
                .then((response) => {
                    this.totalCarsSold = response.data.total
                })
                .catch((error) => {
                    console.log(error)
                })
        }
    }
</script>

<style scoped>
    .card {
        height: 255px;
    }
    .card-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .total {
        font-size: 5rem;
        font-weight: 600;
    }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Manager/Purchases.vue